import { observable, action, makeObservable } from 'mobx';
import CountryApi from "./CountryApi";

import {orderBy} from 'lodash'

export default class CountryStore {
  isLoading = false;

  loaded = false;

  countries = [];

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      loaded: observable,
      countries: observable,
      loadCountries: action,
      onCountriesLoaded: action.bound
    });
  }

  loadCountries() {
    if(!this.countries.length && !this.isLoading && !this.loaded){
      this.isLoading = true;
      return CountryApi.getCountries().then(this.onCountriesLoaded);
    }

    return Promise.resolve(this.countries);
  }

  onCountriesLoaded(resp) {
    this.countries = orderBy(resp, ['name'],['asc']).map(resp => ({
      ...resp,
      textLowercase: resp.name.toLowerCase()
    }));
    this.isLoading = false;
    this.loaded = true;
    return this.countries;
  }

  search = (query) => {
    const countries = this.countries;
    const lowercase = query.toLowerCase();
    return countries.filter(country => country.textLowercase.includes(lowercase));
  };
}